import { AuditDetailsArrayField } from "./AuditDetailsArrayField";
import { AuditDetailsField } from "./AuditDetailsField";
import { AuditLogEntryArrayField } from "./AuditLogEntryArrayField";
import { FileField } from "./FileField";
import { HiddenField } from "./HiddenField";
import { AuditDetailsFormData, AuditLogEntryFormData, Field, FileFormData } from "./models";
import { ReadOnlyField } from "./ReadOnlyField";

export * from "./helpers";
export * from "./models";
export * from "./utils";

export const fieldRegistry: { [name: string]: Field<any> } = {
  AuditDetailsArrayField: AuditDetailsArrayField as Field<AuditDetailsFormData[]>,
  AuditDetailsField: AuditDetailsField as Field<AuditDetailsFormData>,
  AuditLogEntryArrayField: AuditLogEntryArrayField as Field<AuditLogEntryFormData[]>,
  FileField: FileField as Field<FileFormData>,
  HiddenField: HiddenField as Field<any>,
  ReadOnlyField: ReadOnlyField as Field<any>,
};
